<markant-platform-organization-member-details
  class="service-permission"
  slot="highlight-dialog-static-view-content"
  [class.member-invitation]="currentStep === 8"
  [class.service-permission-user]="currentStep === 10"
  [class.service-permission-group]="currentStep === 11"
  [demoContent]="demoConfig"
></markant-platform-organization-member-details>
